module.exports = __webpack_public_path__ + "static/media/fedpa-plus.14dee070.svg";